<template>
  <div class="container-fluid">
    <div class="timeline-form">
      <div class="timeline-form-right w-100">
        <ul class="list-unstyled mb-0 payment-single-transfer">
          <li class="mb-4">
            <h5>Location</h5>
          </li>
          <ValidationObserver v-slot="{ passes }">
            <form @submit.prevent="passes(onlineEvneDataSubmit)" id="location-form" ref="form">
              <ValidationProvider name="hosting_plateform" rules="required" v-slot="{ errors }">
                <div class="hosting_plateform-dropdown">
                  <div
                    class="form-group form-select multiselect-grp"
                    :class="{
                      errors: errors.length && !onlineEvent.hosting_plateform,
                      success: onlineEvent.hosting_plateform,
                    }"
                  >
                    <span class="float-label">
                      <label for="hosting_plateform">Select a Hosting Plateform*</label>
                      <multiselect placeholder="" v-model="onlineEvent.hosting_plateform" :show-labels="false" :options="hosting_options" :searchable="false" label="name" track-by="name">
                        <template slot="hosting_plateform_options" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <i class="fa fa-times" v-if="errors.length && !onlineEvent.hosting_plateform"></i>
                      <i class="fa fa-check" v-if="onlineEvent.hosting_plateform"></i>
                    </span>
                  </div>
                </div>
              </ValidationProvider>
              <li>
                <div class="head">
                  <label>Event URL</label>
                </div>
                <b-input-group>
                  <template #prepend>
                    <b-dropdown variant="outline-secondary" menu-class="border-0 shadow">
                      <template #button-content> https:// </template>
                      <b-dropdown-item> https:// </b-dropdown-item>
                      <b-dropdown-item> http:// </b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <b-form-input v-model="onlineEvent.inputValue"></b-form-input>
                </b-input-group>
              </li>

              <li class="pt-3">
                <h6>Attendee Page Visiblility</h6>

                <div class="form-group">
                  <label class="fancy-radio">
                    <input type="radio" name="visibility_yes" value="visibility_yes" v-model="onlineEvent.attendeeVisibility" />
                    <span><i></i>Enable</span>
                  </label>
                  <label class="fancy-radio">
                    <input type="radio" name="visibility_no" value="visibility_no" v-model="onlineEvent.attendeeVisibility" />
                    <span><i></i>Disable</span>
                  </label>
                  <p id="error-radio"></p>
                </div>
              </li>
              <li class="pl-0">
                <h6>Additional Resources</h6>
                <b-button class="btn btn-lg btn-mw btn-primary" v-b-modal.addResources >Add Resources</b-button>
              </li>
              <li class="pt-3" v-if="onlineEvent.activatedItem.includes('Text')">
                <span class="float-label">
                  <input type="text" autocomplete="off" v-model="onlineEvent.text" class="form-control" id="text" placeholder="Event Text" />
                  <label for="text" class="control-label">Event Text</label>
                  <div class="line"></div>
                </span>
              </li>
              <li class="pt-2" v-if="onlineEvent.activatedItem.includes('Image')">
                <div class="custom-file">
                  <input type="hidden" name="additionalImage" v-model="onlineEvent.additionalImage" accept="image/*" />
                  <input
                    type="file"
                    ref="resetInputFile"
                    id="additionalImage"
                    class="form-control custom-file-input"
                    placeholder="Additinal Image"
                    accept="image/*"
                    @change="eventAdditinalImageChange"
                  /><label class="custom-file-label" for="additionalImage">Choose Image</label>
                </div>
                <div id="preview" class="mt-2" v-if="onlineEvent.additionalImage">
                  <img :src="onlineEvent.additionalImage" />
                  <b-button @click="additinalRemoveImage">Remove image</b-button>
                </div>
              </li>
              <li class="pt-2" v-if="onlineEvent.activatedItem.includes('Video')">
                <label for="Link">Video*</label>
                <b-input-group>
                  <template #prepend>
                    <b-dropdown variant="outline-secondary" menu-class="border-0 shadow">
                      <template #button-content> https:// </template>
                      <b-dropdown-item> https:// </b-dropdown-item>
                      <b-dropdown-item> http:// </b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <b-form-input v-model="onlineEvent.video_url"></b-form-input>
                </b-input-group>
              </li>
              <li class="pt-2" v-if="onlineEvent.activatedItem.includes('Link')">
                <label for="Link">Link*</label>
                <b-input-group>
                  <template #prepend>
                    <b-dropdown variant="outline-secondary" menu-class="border-0 shadow">
                      <template #button-content> https:// </template>
                      <b-dropdown-item> https:// </b-dropdown-item>
                      <b-dropdown-item> http:// </b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <b-form-input v-model="onlineEvent.video_link"></b-form-input>
                </b-input-group>
              </li>
            </form>
          </ValidationObserver>
        </ul>
      </div>
    </div>
    <!-- <b-modal id="addResources" title="Add Resources" no-stacking hide-footer>
      <div class="modal-area">
        <ul class="list-unstyled mb-0">
          <li class="col-lg-12 col-md-12 p-0 m-0">
            <div class="d-flex justify-content-between mb-4 mt-1 who-list">
              <div
                v-for="(item, index) in additional_options"
                :key="index"
                class="align-items-center border d-flex flex-column justify-content-center flex-grow-1 p-3 who-box"
                @click="selectAdditionalInfo(item.name)"
                :class="[
                  onlineEvent.activated == item.name || onlineEvent.tempActivatedItem.includes(item.name) ? 'active' : '',
                  item.dynamicClass == 'ml-2' ? 'ml-2' : '',
                  item.dynamicClass == 'ml-2' ? 'ml-2' : '',
                ]"
              >
                <div class="btn btn-primary btn-lg mb-1">
                  <i :class="[onlineEvent.activated == item.name || onlineEvent.tempActivatedItem.includes(item.name) ? 'text-primary' : '', item.icon != '' ? item.icon : '']"></i>
                </div>
                <h6 class="mb-0 mt-3">{{ item.name }}</h6>
              </div>
            </div>
          </li>
          <li class="d-flex align-items-center flex-column">
            <b-button type="submit" class="btn btn-lg mb-2 w-50 btn-primary btn-lg" @click="addResourcesInOnline()" >Add</b-button>
            <b-button @click="$bvModal.hide('addResources')" class="btn btn-outline-secondary mr-1 btn-lg w-50">CANCEL</b-button>
          </li>
        </ul>
      </div>
    </b-modal> -->
  </div>
</template>
<script>
//import BreadCrumb from "@/components/BreadCrumb";
import { ValidationObserver, ValidationProvider } from "vee-validate";

//import EventTimeline from "@/components/core/EventTimeline";

export default {
  name: "EventFormOnline",
  components: {
    //BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import('vue-multiselect'),
    //"events-timeline": EventTimeline,
  },
  data() {
    return {
      onlineEvent: {
        activated: null,
        activatedItem: [],
        tempActivatedItem: [],
        hosting_plateform: "",
        inputValue: "",
        event_image: null,
        additionalImage: null,
        attendeeVisibility: "visibility_yes",
        text: "",
        video_url: "",
        video_link: "",
      },

      hosting_options: [{ name: "Microsoft Teamviewer" }, { name: "Zoom" }, { name: "Google meet" }, { name: "Skype" }],

      additional_options: [
        { name: "Text", icon: "fa fa-text-width", dynamicClass: "" },
        { name: "Image", icon: "fa fa-picture-o", dynamicClass: "ml-2" },
        { name: "Video", icon: "fa fa-video-camera", dynamicClass: "ml-2" },
        { name: "Link", icon: "fa fa-link", dynamicClass: "ml-2" },
      ],
    };
  },
  methods: {
    eventImageChange(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.onlineEvent.event_image = URL.createObjectURL(file);
      }
    },
    eventAdditinalImageChange(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.onlineEvent.additionalImage = URL.createObjectURL(file);
      }
    },
    removeImage: function () {
      this.$refs.resetInputFile.value = null;
      this.onlineEvent.event_image = null;
    },

    additinalRemoveImage: function () {
      this.$refs.resetInputFile.value = null;
      this.onlineEvent.additionalImage = null;
    },
    //submit form data
    onlineEvneDataSubmit() {
      this.$router.push({ path: "/ticket/ticket-list" });
    },
    selectAdditionalInfo(currentActive) {
      this.onlineEvent.activated = currentActive;
      if (this.onlineEvent.tempActivatedItem.includes(this.onlineEvent.activated)) {
        let index = this.onlineEvent.tempActivatedItem.indexOf(this.onlineEvent.activated);
        this.onlineEvent.tempActivatedItem.splice(index, 1);
        this.onlineEvent.activated = "";
      } else {
        this.onlineEvent.tempActivatedItem.push(this.onlineEvent.activated);
      }
    },

    addResourcesInOnline() {
      this.onlineEvent.activatedItem = this.onlineEvent.tempActivatedItem;
      this.$bvModal.hide("addResources");
    },
  },
  mounted() {},
};
</script>
